// extracted by mini-css-extract-plugin
export default {"home":"Home_home__MrGr3","homeHeading":"Home_homeHeading__vAG5j","homeLeft":"Home_homeLeft__MFv6I","homeRight":"Home_homeRight__YXwhv","contactOnHome":"Home_contactOnHome__iwWUm"};